<template>
    <div>
      <span class="sec-description">{{ $t('diagnostic.moments.description') }}<br><i>{{sectionDescription}}</i></span>

       <table v-if="momentsData" cellspacing="0" cellpadding="0">
        <thead>
          <tr>
            <th class="hide"></th>
            <th colspan="2">{{ $t('diagnostic.moments.dates.monday_thursday') }}</th>
            <th colspan="2">{{ $t('diagnostic.moments.dates.friday_sunday') }}</th>
            
          </tr>
          <tr class="sales">
            <th>{{ $t('diagnostic.moments.sales.time_slot') }}</th>
            <th>{{ $t('general.sales') }}</th>
            <th>{{ $t('diagnostic.moments.sales.gc') }}</th>
            <th>{{ $t('general.sales') }}</th>
            <th>{{ $t('diagnostic.moments.sales.gc') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in momentsData">

            <template v-for="(weekitem, weekindex) in item">
            <td v-if="weekindex==1">{{weekitem.name}}</td>
              <template v-for="(salesitem, salesindex) in weekitem">
                <td v-if="salesitem>0.5"><img src='/img/up_arrow.svg'> {{parseFloat(salesitem).toFixed(2)}}%</td>
                <td v-else-if="salesitem<-0.5"><img src='/img/down_arrow.svg'> {{parseFloat(salesitem).toFixed(2)}}%</td>
                <td v-else-if="salesitem<=0.5 && salesitem>=-0.5"><img src='/img/equal.svg'> {{parseFloat(salesitem).toFixed(2)}}%</td>
                <td v-else-if="salesitem=='-'">-</td>
              </template>
            </template>
          </tr>
        </tbody>
      </table>

      <div v-else class="msg-alert">{{ $t('general.empty') }}</div>

    </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  computed: {
    sectionDescription() {
      var section = this.$store.getters['locations/getDiagnosticDescriptions']['sales']
      if (section && section.description) {
        return section.description;
      } else return false;
    },

    selectedLocation() {
      return this.$store.getters['locations/getSelectedLocation'];
    },

    momentsData() {
      var data = this.$store.getters['locations/getMomentsOfDay'];
      var count = 0;
      for(var element in data ){
        for(var i in data[element]) {
          if(data[element][i].gcs != '-' && data[element][i].sales != '-') count++;
        }
      }
      return (count > 0)? data : false;
    }
  },
  methods: {
  },
  watch: {
    selectedLocation () {
      if (this.selectedLocation==undefined){
        this.$store.getters['locations/getSelectedLocation'];
      }
      this.$store.dispatch('locations/loadMomentsOfDay', this.selectedLocation.id );
     },
  },
  created() {
    this.$store.dispatch('locations/loadMomentsOfDay', this.selectedLocation.id );
  },
  beforeRouteLeave (to, from, next) {
      next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .sec-description {
    display: block;
    color: #999;
    margin-bottom: 40px;
  }

  .msg-alert {
    background-color: #d6eaec;
    padding: 10px 20px;
    width: fit-content;
    margin: 0 auto;
    margin-bottom: 40px;
  }


  /* TABLE STYLES */
  table {
      margin: 0 auto;
      border-color: white;
      width: 95%;

    &.changed {

    }

      &.weekend {
        margin-top: 40px;
      }

      .hide {
        visibility: hidden !important;
        opacity: 0 !important;
      }

      thead {

        tr {

          &.sales {
            //background-color: black;
            //color: white;

            th {
              background-color: transparent;
            }
          }
          th {
            background-color: transparent;
            border-bottom: 1px solid var(--main_color);
            height: 50px;
            text-transform: uppercase;
            padding: 0px 10px;
          }
        }
      }
        
      tr {
        //background-color: rgba(255,255,255,0.5);
        height: 50px;

        &.separator {
          td {
            border-bottom: 1px solid #777;
          }
        }
      }
      
      tbody {
        //background-color: var(--main_color);
        tr:nth-child(odd) {
          //background-color: rgba(255,255,255,0.7);

          .editable {
            //background-color: rgba(255,255,255,1);
          }
        }
      }


      td {
        text-transform: uppercase;
        font-weight: bold;
        padding: 0px 5px;
        text-align: left;
        width: 10%;
        text-align: center;
        border-bottom: 1px solid #ddd;
        background-color: rgba(255,255,255,0.7);



        img {
          height: 20px;
          width: 20px;
          position: relative;
          top: 5px;
          margin-right: 5px;
        }

        .description {
          display: block;
          text-transform: none;
          font-weight: normal;
          font-size: 13px;
        }
      }

      td {
        overflow: hidden;

        &.editable {
          position: relative;
        }

        input {
          height: 40px;
          text-align: center;
          font-size: 17px;
          appearance: textfield;
          width: 100%;
          outline:0px;
        }

        &:hover {
          input {
            background-color: #eee;

          }
        }

        select {
          font-size: 15px;
          padding: 8px;
          font-weight: lighter;
        }

        .suffix {
          position: absolute;
          left: calc(50% + 8px);
          top: 15px;
          display: inline;
        }
      }

      .summary {
        td {
          background-color: #333;
          color: #fff;
        }
      }
    }

</style>
